export const config = {
  appName: 'Atomic Habits'
};